var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { resolve } from 'rsvp';
import { and } from '@ember/object/computed';
import { isNone } from '@ember/utils';
import Service, { inject as service } from '@ember/service';
import Enum from '@square/dashboard-utilities/utils/enum';
import { DefaultDeviceProfilesRequest, TippingSettings, SeatingSettings, AppearanceSettings, KDSFetchSettings, KDSUISettings, CheckoutSettings } from '@square/dashboard-protos/models/squareup/client/device_settings/device_profile';
import deviceProfile from '@square/dashboard-data/clients/device-profile';
import DeviceProfile from '@square/dashboard-data/models/device-profile';
import { DeviceType } from '@square/dashboard-utilities/utils/devices/device-type';
import KdsTimerSetting from '@square/dashboard-data/models/kds-timer-setting';
import KdsLayout from '@square/dashboard-data/models/kds-layout';
import KdsCategoryConfiguration from '@square/dashboard-data/models/kds-category-configuration';
import { set } from '@ember/object';
export const RestaurantsDeviceType = new Enum(['QUICK_SERVICE', 'TABLE_SERVICE', 'SELF_SERVICE', 'BAR_LOUNGE', 'OTHER']);
let DefaultDeviceProfiles = (_dec = and('userSubscriptions.{isPayingRstSubscriber,isSubscribedToRetail}'), _class = class DefaultDeviceProfiles extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor, this);
    _initializerDefineProperty(this, "kioskProfilesService", _descriptor2, this);
    _defineProperty(this, "deviceProfilesResponse", null);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "hasCouldNotFetchProfileError", false);
    // Restaurants Plus users can create Restaurants Shared Settings
    // Retail Plus and Retail Free users can create Retail Shared Settings
    _initializerDefineProperty(this, "canCreateRestaurantsAndRetailSharedSettings", _descriptor3, this);
  }
  createDefault(deviceType = DeviceType.REGISTER, options = {}) {
    const deviceProfile = DeviceProfile.createDefault();
    let posProfileFunc = null;
    let posProfileType = null;
    switch (deviceType) {
      case DeviceType.RETAIL:
        posProfileFunc = this._retail;
        posProfileType = DeviceType.RETAIL;
        break;
      case DeviceType.RESTAURANT:
        posProfileType = DeviceType.RESTAURANT;
        posProfileFunc = this._restaurantsDefaultsFuncFromDeviceType(options.restaurantsDeviceType);
        break;
      case DeviceType.RESTAURANT_MOBILE:
        posProfileType = DeviceType.RESTAURANT_MOBILE;
        posProfileFunc = this._restaurantsDefaultsFuncFromDeviceType(options.restaurantsDeviceType);
        break;
      case DeviceType.KDS:
        posProfileFunc = this._kds;
        posProfileType = DeviceType.KDS;
        break;
      case DeviceType.KDS_EXPO:
        posProfileFunc = this._kdsExpo;
        posProfileType = DeviceType.KDS_EXPO;
        break;
      case DeviceType.FNBKIOSK:
        posProfileType = DeviceType.FNBKIOSK;
        posProfileFunc = this._fnbKiosk;
        break;
      case DeviceType.REGISTER:
      default:
        posProfileFunc = this._pointOfSale;
        posProfileType = DeviceType.REGISTER;
        break;
    }

    // This function has a entry point from restaurants-device-type-modal which passes RESTAURANT deviceType
    // We want to set the posProfileType to FNBKIOSK instead of RESTAURANT
    if (options.restaurantsDeviceType === RestaurantsDeviceType.SELF_SERVICE) {
      posProfileType = DeviceType.FNBKIOSK;
      posProfileFunc = this._fnbKiosk;
    }
    return posProfileFunc.call(this).then(profile => {
      const settings = deviceProfile.get('settings');
      this._overlayProfile(settings, profile);
      settings.set('type', posProfileType);
      return deviceProfile;
    });
  }
  _pointOfSale() {
    return this._defaultDeviceProfiles().then(({
      pointOfSaleDefault
    }) => pointOfSaleDefault);
  }
  _retail() {
    return this._defaultDeviceProfiles().then(({
      retailDefault
    }) => retailDefault);
  }
  _restaurantsDefaultsFuncFromDeviceType(restaurantsDeviceType) {
    switch (restaurantsDeviceType) {
      case RestaurantsDeviceType.TABLE_SERVICE:
        return this._restaurantsTableService;
      case RestaurantsDeviceType.QUICK_SERVICE:
        return this._restaurantsQuickService;
      case RestaurantsDeviceType.SELF_SERVICE:
        return this._fnbKiosk;
      case RestaurantsDeviceType.BAR_LOUNGE:
      case RestaurantsDeviceType.OTHER:
      default:
        return this._restaurantsBarLounge;
    }
  }
  _kds() {
    return this._defaultDeviceProfiles().then(({
      kdsDefault
    }) => kdsDefault);
  }
  _kdsExpo() {
    return this._defaultDeviceProfiles().then(({
      kdsExpoDefault
    }) => kdsExpoDefault);
  }
  _restaurantsQuickService() {
    return this._defaultDeviceProfiles().then(({
      rstQuickServiceDefault
    }) => rstQuickServiceDefault);
  }
  _restaurantsTableService() {
    return this._defaultDeviceProfiles().then(({
      rstTableServiceDefault
    }) => rstTableServiceDefault);
  }
  _restaurantsBarLounge() {
    return this._defaultDeviceProfiles().then(({
      rstBarLoungeDefault
    }) => rstBarLoungeDefault);
  }
  _fnbKiosk() {
    return this.kioskProfilesService.getDefaultDiningOptions().then(defaultDiningOptions => {
      return this._defaultDeviceProfiles().then(({
        fnbKioskDefault
      }) => {
        return {
          ...fnbKioskDefault,
          fnbKiosk: {
            diningOptions: defaultDiningOptions
          }
        };
      });
    });
  }
  _defaultDeviceProfiles() {
    if (isNone(this.deviceProfilesResponse)) {
      set(this, 'isLoading', true);
      return deviceProfile.defaultDeviceProfiles(DefaultDeviceProfilesRequest.create()).then(deviceProfilesResponse => {
        set(this, 'hasCouldNotFetchProfileError', false);
        set(this, 'deviceProfilesResponse', deviceProfilesResponse);
        return deviceProfilesResponse;
      }).catch(err => {
        set(this, 'hasCouldNotFetchProfileError', true);
        set(this, 'deviceProfilesResponse', null); // force a retry when an error occurs
        throw err;
      }).finally(() => {
        set(this, 'isLoading', false);
      });
    }
    // return cached response if it exists
    return resolve(this.deviceProfilesResponse);
  }
  _overlayProfile(settings, profile) {
    if (profile.cashManagement) {
      this._overlayCashManagement(settings, profile.cashManagement);
    }
    if (profile.checkout) {
      this._overlayCheckout(settings, profile.checkout);
    }
    if (profile.employeeManagement) {
      this._overlayEmployeeManagement(settings, profile.employeeManagement);
    }
    if (profile.openTickets) {
      this._overlayOpenTickets(settings, profile.openTickets);
    }
    if (profile.tipping) {
      this._overlayTipping(settings, profile.tipping);
    }
    if (profile.customerManagement) {
      this._overlayCustomerManagement(settings, profile.customerManagement);
    }
    if (profile.textCustomer) {
      this._overlayTextCustomer(settings, profile.textCustomer);
    }
    if (profile.seating) {
      this._overlaySeating(settings, profile.seating);
    }
    if (profile.autoGratuity) {
      this._overlayAutoGratuity(settings, profile.autoGratuity);
    }
    if (profile.courseManagement) {
      this._overlayCourseManagement(settings, profile.courseManagement);
    }
    if (profile.floorPlan) {
      this._overlayFloorPlan(settings, profile.floorPlan);
    }
    if (profile.hardware) {
      this._overlayHardware(settings, profile.hardware);
    }
    if (profile.appearance) {
      this._overlayAppearance(settings, profile.appearance);
    }
    if (profile.orderHub) {
      this._overlayOrderHub(settings, profile.orderHub);
    }
    if (profile.kdsFetch) {
      this._overlayKdsFetch(settings, profile.kdsFetch);
    }
    if (profile.kdsUi) {
      this._overlayKdsUi(settings, profile.kdsUi);
    }
    if (profile.ordersMode) {
      this._overlayOrdersMode(settings, profile.ordersMode);
    }
    if (profile.fnbKiosk) {
      this._overlayFnbKiosk(settings, profile.fnbKiosk);
    }
  }
  _overlayCashManagement(settings, cashManagement) {
    this._setPropertyFromProto(settings, cashManagement, 'useCashDrawers');
    this._setPropertyFromProto(settings, cashManagement, 'defaultStartingAmount');
    this._setPropertyFromProto(settings, cashManagement, 'printReport');
    this._setPropertyFromProto(settings, cashManagement, 'emailReport');
    // recipientEmployeeToken: attr(String),
    this._setPropertyFromProto(settings, cashManagement, 'recipientAddress');
  }
  _overlayCheckout(settings, checkout) {
    this._setPropertyFromProto(settings, checkout, 'usePaperSignature');
    this._setPropertyFromProto(settings, checkout, 'skipSignature');
    this._setPropertyFromProto(settings, checkout, 'storeAndForwardEnabled');
    this._setPropertyFromProto(settings, checkout, 'storeAndForwardSingleTransactionLimit');
    this._setPropertyFromProto(settings, checkout, 'skipReceiptScreen');
    this._setPropertyFromProto(settings, checkout, 'forPaperSignatureUseQuickTipReceipt');
    this._setPropertyFromProto(settings, checkout, 'skipSignatureAlways');
    this._setPropertyFromProto(settings, checkout, 'orderTicketNamingType', CheckoutSettings.OrderTicketNamingType);
    this._setPropertyFromProto(settings, checkout, 'useBuyerFacingScreen');
    this._setPropertyFromProto(settings, checkout, 'showBuyerFacingOrderSummary');
    // paperSignatureTipType: attr(PrintedReceiptTypes, { defaultValue: PrintedReceiptTypes.UNSET }),
    // forPaperSignaturePrintAdditionalAuthSlip: attr(Boolean, { defaultValue: false }),
    // forPaperSignaturePrintItemizedAuthSlip: attr(Boolean, { defaultValue: false }),
  }
  _overlayEmployeeManagement(settings, employeeManagement) {
    this._setPropertyFromProto(settings, employeeManagement, 'trackEmployee');
    this._setPropertyFromProto(settings, employeeManagement, 'trackTime');
    this._setPropertyFromProto(settings, employeeManagement, 'inactivityTimeout');
    this._setPropertyFromProto(settings, employeeManagement, 'trackingLevel');
    this._setPropertyFromProto(settings, employeeManagement, 'requiresEmployeeLogoutAfterCompletedTransaction');
    this._setPropertyFromProto(settings, employeeManagement, 'requirePasscodeWhenBackingOutOfBuyerFacingScreen');
  }
  _overlayOpenTickets(settings, openTickets) {
    this._setPropertyFromProto(settings, openTickets, 'openTicketsEnabled');
    this._setPropertyFromProto(settings, openTickets, 'useOpenTicketsMenuAsHomeScreen');
    this._setPropertyFromProto(settings, openTickets, 'usePredefinedTickets');
  }
  _overlayTipping(settings, tipping) {
    this._setPropertyFromProto(settings, tipping, 'tippingEnabled');
    this._setPropertyFromProto(settings, tipping, 'tippingUseCustomPercentages');
    this._setPropertyFromProto(settings, tipping, 'tippingPercentageTipAmount');
    this._setPropertyFromProto(settings, tipping, 'tippingUseManualTipEntry');
    this._setPropertyFromProto(settings, tipping, 'tippingCalculationPhase', TippingSettings.TippingCalculationPhase);
    this._setPropertyFromProto(settings, tipping, 'useSeparateTippingScreen');
  }
  _overlayCustomerManagement(settings, customerManagement) {
    this._setPropertyFromProto(settings, customerManagement, 'collectBeforeCheckout');
    this._setPropertyFromProto(settings, customerManagement, 'collectAfterCheckout');
    this._setPropertyFromProto(settings, customerManagement, 'useCardOnFile');
    this._setPropertyFromProto(settings, customerManagement, 'showSaveCardButtonAfterCheckout');
    // TODO(RETAIL-7714): Remove this attribute from device profiles.
    this._setPropertyFromProto(settings, customerManagement, 'showAddCustomerCartRow');
    this._setPropertyFromProto(settings, customerManagement, 'showEmailCollectionScreen');
  }
  _overlayTextCustomer(settings, textCustomer) {
    this._setPropertyFromProto(settings, textCustomer, 'promptBeforeCheckout');
  }
  _overlaySeating(settings, seating) {
    this._setPropertyFromProto(settings, seating, 'seatingEnabled');
    this._setPropertyFromProto(settings, seating, 'seatAssignmentOption', SeatingSettings.SeatAssignmentOption);
  }
  _overlayAutoGratuity(settings, autoGratuity) {
    this._setPropertyFromProto(settings, autoGratuity, 'autoGratuityEnabled');
  }
  _overlayCourseManagement(settings, courseManagement) {
    this._setPropertyFromProto(settings, courseManagement, 'courseManagementEnabled');
    this._setPropertyFromProto(settings, courseManagement, 'expandFiredItemsSectionByDefault');
    this._setPropertyFromProto(settings, courseManagement, 'kitchenControlsFire');
  }
  _overlayFloorPlan(settings, floorPlan) {
    this._setPropertyFromProto(settings, floorPlan, 'showFloorPlanTimers');
    this._setPropertyFromProto(settings, floorPlan, 'useTableInactivityIndicators');
    this._setPropertyFromProto(settings, floorPlan, 'tableIndicatorWarningTime');
    this._setPropertyFromProto(settings, floorPlan, 'tableIndicatorAlertTime');
  }
  _overlayHardware(settings, hardware) {
    this._setPropertyFromProto(settings, hardware, 'requireCardReader');
    this._setPropertyFromProto(settings, hardware, 'requireCashDrawer');
    this._setPropertyFromProto(settings, hardware, 'requirePrinter');
  }
  _overlayAppearance(settings, appearance) {
    this._setPropertyFromProto(settings, appearance, 'userInterfaceStyle', AppearanceSettings.UserInterfaceStyle);
  }
  _overlayOrderHub(settings, orderHub) {
    this._setPropertyFromProto(settings, orderHub, 'useOrderHub');
  }
  _overlayKdsFetch(settings, kdsFetch) {
    if (kdsFetch.categories) {
      this._overlayKdsFetchCategories(settings, kdsFetch);
    }
    this._setPropertyFromProto(settings, kdsFetch, 'categories');
    this._setPropertyFromProto(settings, kdsFetch, 'uncategorizedEnabled');
    this._setPropertyFromProto(settings, kdsFetch, 'includeFutureCategoriesEnabled');
    this._setPropertyFromProto(settings, kdsFetch, 'ordersEnabled');
    this._setPropertyFromProto(settings, kdsFetch, 'displayOrderOnState', KDSFetchSettings.DisplayOrderConfigurationState);
    this._setPropertyFromProto(settings, kdsFetch, 'posEnabled');
    this._setPropertyFromProto(settings, kdsFetch, 'stationOnPickupBufferSeconds');
    this._setPropertyFromProto(settings, kdsFetch, 'posDeviceConfigurations');
    this._setPropertyFromProto(settings, kdsFetch, 'includeFutureNamedPosEnabled');
    this._setPropertyFromProto(settings, kdsFetch, 'includeUnnamedPosEnabled');
    this._setPropertyFromProto(settings, kdsFetch, 'diningOptionConfigurations');
    this._setPropertyFromProto(settings, kdsFetch, 'includeFutureDiningOptionsEnabled');
  }
  _overlayKdsFetchCategories(settings, kdsFetch) {
    if (Array.isArray(kdsFetch.categories)) {
      const copyOfArray = [];
      kdsFetch.categories.forEach(val => {
        const category = KdsCategoryConfiguration.create();
        this._setPropertyFromProto(category, val, 'catalogObjectToken');
        this._setPropertyFromProto(category, val, 'enabled');
        copyOfArray.push(category);
      });
      settings.set('categories', copyOfArray);
    }
  }
  _overlayKdsUi(settings, kdsUi) {
    if (kdsUi.timerSettings) {
      this._overlayKdsUiTimerSettings(settings, kdsUi);
    }
    if (kdsUi.enabledSounds) {
      this._overlayKdsUiEnabledSounds(settings, kdsUi);
    }
    // this._setPropertyFromProto(settings, kdsUi, 'enabledSounds', KDSUISettings.SoundType);
    if (kdsUi.layout) {
      this._overlayKdsUiLayout(settings, kdsUi.layout);
    }
    this._setPropertyFromProto(settings, kdsUi, 'textSize', KDSUISettings.TextSize);
  }
  _overlayKdsUiTimerSettings(settings, kdsUi) {
    if (Array.isArray(kdsUi.timerSettings)) {
      const copyOfArray = [];
      kdsUi.timerSettings.forEach(val => {
        const timerSetting = KdsTimerSetting.create();
        this._setPropertyFromProto(timerSetting, val, 'timerEnabled');
        this._setPropertyFromProto(timerSetting, val, 'fireInterval');
        this._setPropertyFromProto(timerSetting, val, 'color', KDSUISettings.TimerColor);
        copyOfArray.push(timerSetting);
      });
      settings.set('timerSettings', copyOfArray);
    }
  }
  _overlayKdsUiEnabledSounds(settings, kdsUi) {
    if (Array.isArray(kdsUi.enabledSounds)) {
      const copyOfArray = [];
      kdsUi.enabledSounds.forEach(val => {
        copyOfArray.push(KDSUISettings.SoundType[val]);
      });
      settings.set('enabledSounds', copyOfArray);
    }
  }
  _overlayKdsUiLayout(settings, kdsUiLayout) {
    const kdsLayout = KdsLayout.create();
    this._setPropertyFromProto(kdsLayout, kdsUiLayout, 'layoutType', KDSUISettings.LayoutType);
    this._setPropertyFromProto(kdsLayout, kdsUiLayout, 'fixedLayoutRows');
    this._setPropertyFromProto(kdsLayout, kdsUiLayout, 'fixedLayoutColumns');
    settings.set('layout', kdsLayout);
  }
  _overlayOrdersMode(settings, ordersMode) {
    this._setPropertyFromProto(settings, ordersMode, 'ordersModeEnabled');
  }
  _overlayFnbKiosk(settings, fnbKiosk) {
    this._setPropertyFromProto(settings, fnbKiosk, 'allowGiftCards');
    this._setPropertyFromProto(settings, fnbKiosk, 'diningOptions');
  }
  _setPropertyFromProto(settings, proto, propertyName, propertyEnum) {
    if (Object.prototype.hasOwnProperty.call(proto, propertyName)) {
      if (propertyEnum) {
        settings.set(propertyName, propertyEnum[proto[propertyName]]);
      } else {
        settings.set(propertyName, proto[propertyName]);
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "kioskProfilesService", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canCreateRestaurantsAndRetailSharedSettings", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DefaultDeviceProfiles as default };